
export type NotificationGetNotificationsParams = {
/**
 * 읽지 않은 알림만 조회
 */
unreadOnly?: boolean;
/**
 * 페이지 번호
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
